<template>

    <a-yoga-layout
        width-auto="1" height-auto="1"
        padding="0"
        flex-direction="row"
        yoga-layout-item=""

        geometry="primitive: plane;" material="visible: false"
    >
        <a-image
            :src="block.field_values.image.url"
            :width="imageWidth"
            :height="imageHeight"
        ></a-image>

    </a-yoga-layout>

</template>

<script>
export default {
    name: "ImageAlone",
    props: ['block'],
    computed: {
        imageWidth() {
            return 2;
        },
        imageHeight() {
            return this.block.field_values.image.height * this.imageWidth / this.block.field_values.image.width;
        },
    },
}
</script>

<style scoped>

</style>